import React from 'react';
import { Table } from 'antd';
import { CaseItem } from '../../Contexts/types';
import { useParams } from 'react-router-dom';

interface CaseDocument {
    id: string;
    title: string;
    url: string;
    description: string;
}
interface CaseDetailsProps {
    cases: CaseItem[];
}
  

const CaseDocuments: React.FC<CaseDetailsProps> = ({ cases }) => {
    const { id } = useParams<{ id: string }>();
    // const caseId = id;
    const caseDetails = cases.find((caseItem) => caseItem.basicData.id === id);
    const title = caseDetails?.basicData.title
    
  const columns = [
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_text: string, record: CaseDocument) => (
        <a href={record.url} target="_blank" rel="noopener noreferrer">
          View Document
        </a>
      ),
    },
  ];

  return (
    <div>
        <div className='form-header'>Case Documents for {title}</div>
        <Table 
            columns={columns} 
            dataSource={caseDetails?.documents} 
            rowKey="id" 
            pagination={false} 
            className="custom-table ant-table"
        />
    </div>
    
  );
};

export default CaseDocuments;
